export const allowedProps = ['data-selenium-test', 'placeholder', 'onChange', 'value', 'disabled', 'readOnly'];
/**
 * Filter out props that are not supported by Canvas components.
 *
 * Canvas components pass all the props they receive to the native HTML elements
 * as {...rest}. That makes react complain about unrecognized props
 * e.g "Warning: React does not recognize the filterFamily prop on a DOM element."
 */
export const getTransferableProps = props => {
  return allowedProps.reduce((acc, key) => {
    if (props[key]) {
      acc[key] = props[key];
    }
    return acc;
  }, {});
};
export const filterInputProps = (props, allowedKeys) => {
  return allowedKeys.reduce((acc, key) => {
    if (props[key]) {
      acc[key] = props[key];
    }
    return acc;
  }, {});
};